export const en = {
  job_desc: [
    {
      title: 'Qualification: ',
      content: [
        'Bachelor/Master degree in Computer Science/Computer Engineer or related',
        'Experience 1-2 years'
      ]
    },
    {
      title: 'Responsibilities: ',
      content: [
        'Developing new application features using React.js and React Native',
        'Maintenance the existing application',
        'Optimizing components for maximum performance across a vast array of web-capable devices and browsers',
        'Coordinate with the internal team to provide technical support.'
      ]
    },
    {
      title: 'Skills: ',
      content: [
        'Strong proficiency in HTML5, CSS.',
        'Strong proficiency in JavaScript, including DOM manipulation and the JavaScript object model',
        'Thorough understanding of React.js/React Native and its core principles.',
        'Thorough understanding of Node.js and its core principles.',
        'Familiarity with RESTful APIs.',
        'Familiarity with GraphQL is a plus.',
        'Familiarity with Github.'
      ]
    }
  ],
  similar_jobs: [
    {
      title: 'Front End Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 0
    },
    {
      title: 'Back End Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 1
    },
    {
      title: 'Full-stack Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 2
    },
  ]
}

export const th = {
  job_desc: [
    {
      title: 'Qualification: ',
      content: [
        'Bachelor/Master degree in Computer Science/Computer Engineer or related',
        'Experience 1-2 years'
      ]
    },
    {
      title: 'Responsibilities: ',
      content: [
        'Developing new application features using React.js and React Native',
        'Maintenance the existing application',
        'Optimizing components for maximum performance across a vast array of web-capable devices and browsers',
        'Coordinate with the internal team to provide technical support.'
      ]
    },
    {
      title: 'Skills: ',
      content: [
        'Strong proficiency in HTML5, CSS.',
        'Strong proficiency in JavaScript, including DOM manipulation and the JavaScript object model',
        'Thorough understanding of React.js/React Native and its core principles.',
        'Thorough understanding of Node.js and its core principles.',
        'Familiarity with RESTful APIs.',
        'Familiarity with GraphQL is a plus.',
        'Familiarity with Github.'
      ]
    }
  ],
  similar_jobs: [
    {
      title: 'Front End Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 0
    },
    {
      title: 'Back End Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 1
    },
    {
      title: 'Full-stack Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 2
    }
  ]
}
